export default __webpack_public_path__ + "static/media/jp.4c804454.svg";